import React from 'react';
import { Icon } from 'antd';
import classNames from 'classnames';

export default function TypeFilterItem({ type, isSelected, updateFilter, clearFilter }) {
  return (
    <li onClick={(updateFilter) ? updateFilter(type.id) : null}
        className={classNames('filter-item',
          { 'filter-item-active': isSelected })}
    >

      {
        (isSelected) ?
          <Icon type="close"
                className="p-absolute bordered circled"
                onClick={clearFilter(type.id)}
          /> : null
      }
      <div>{type.name}</div>
    </li>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Types/components/TypeFilterList/TypeFilterItem.js